import { useSelector } from 'react-redux';
import { getSortParamForHistoryPage } from '../ducks';

export const useGetSortHistoryParam = () => ({
  sortHistoryParam: useSelector(getSortParamForHistoryPage),
});
